<!--app\javascript\dashboard\routes\dashboard\bulkmessage\pages\BulkMessageHistory.vue-->

<script setup>
import { ref } from 'vue';

// Components
import ToastFix from 'dashboard/components-next/toast/ToastFix.vue';
import BroadcastHistory from '../components/BroadcastHistory.vue';
import BroadcastDetail from '../components/BroadcastDetail.vue';

// State
const selectedBroadcastId = ref(null);

// Methods
const showBroadcastDetails = id => {
  selectedBroadcastId.value = id;
};
</script>

<template>
  <div class="flex flex-col h-full bg-n-background w-full overflow-hidden">
    <!-- Header -->
    <header
      class="flex justify-between items-center h-14 min-h-[3.5rem] px-4 py-2 bg-n-background border-b border-n-weak pl-6"
    >
      <div class="flex items-center gap-2">
        <woot-sidemenu-icon v-if="showSidemenuIcon" />
        <h1
          class="flex items-center mb-0 text-xl sm:text-2xl text-slate-900 dark:text-slate-100"
        >
          Histórico de Disparos
        </h1>
      </div>
    </header>

    <!-- Componente de correção de toast -->
    <ToastFix />

    <!-- Área principal de conteúdo -->
    <div class="flex-1 min-h-0 overflow-y-auto overflow-x-hidden relative">
      <!-- History Content -->
      <div class="w-full max-w-7xl mx-auto p-4 sm:p-6">
        <!-- Import and use the BroadcastHistory component directly -->
        <BroadcastHistory
          v-if="!selectedBroadcastId"
          @view-details="showBroadcastDetails"
        />
        <BroadcastDetail
          v-else
          :broadcast-id="selectedBroadcastId"
          @back="selectedBroadcastId = null"
        />
      </div>
    </div>
  </div>
</template>

<style scoped>
/* Copy the same basic styles from the original BulkMessage.vue */
:root {
  --primary-color: #2b70e0ff;
  --primary-hover: #3b7eeb;
  --light-primary: #f8f8f8ff;
  --light-primary-hover: #f0f0f3ff;
  --white: #ffffffff;
  --black: #0c0d11ff;
  --bg: #fdfdfdff;
  --light-gray: #f0f0f3ff;
  --text-gray: #5e5e5eff;
  --danger-color: #b31a30ff;
  --success-color: #1cb954;
  --shadow-sm: 0 2px 4px rgba(0, 0, 0, 0.05);
  --shadow-md: 0 4px 6px rgba(0, 0, 0, 0.1);
  --shadow-lg: 0 10px 15px rgba(0, 0, 0, 0.1);
  --border-radius: 8px;
  --transition-speed: 0.2s;
}

/* Clean structure following agentis pattern - no extra whitespace */
.broadcast-detail {
  width: 100%;
  max-width: 100%;
}

/* Responsividade melhorada */
@media (max-width: 640px) {
  /* Mobile adjustments */
  .broadcast-detail table {
    font-size: 0.875rem;
  }
}

@media (max-width: 768px) {
  /* Tablet adjustments */
  table {
    font-size: 0.875rem;
  }
}
</style>
